import { Provider } from '@app/shared/models/provider';
import { Action, createReducer, on } from '@ngrx/store';
import { SsoActions } from '../actions';
import { Domain } from '@app/shared/models/domain';


export const ssoFeatureKey = 'sso';

export interface State {
  provider: Provider;
  providerLoading: boolean;
  providerError: any;

  providerUpdating: boolean;
  providerUpdatingError: any;

  domains: Domain[];
  domainsLoading: boolean;
  domainsError: any;
}

export const initialState: State = {
  provider: null,
  providerLoading: false,
  providerError: null,

  providerUpdating: false,
  providerUpdatingError: null,

  domains: [],
  domainsLoading: false,
  domainsError: null,
};

const ssoReducer = createReducer(
  initialState,
  on(SsoActions.getMainProvider, (state) => ({
    ...state,
    providerLoading: true,
  })),
  on(SsoActions.getMainProviderSuccess, (state, { provider }) => ({
    ...state,
    provider: { ...provider },
    providerLoading: false,
    providerError: null
  })),
  on(SsoActions.getMainProviderFailure, (state, { error }) => ({
    ...state,
    providerLoading: false,
    providerError: error
  })),
  on(SsoActions.createProvider, (state) => ({
    ...state,
    providerUpdating: true,
  })),
  on(SsoActions.createProviderSuccess, (state, { provider }) => ({
    ...state,
    provider: { ...provider },
    providerUpdating: false,
    providerUpdatingError: null
  })),
  on(SsoActions.createProviderFailure, (state, { error }) => ({
    ...state,
    providerUpdating: false,
    providerUpdatingError: error
  })),
  on(SsoActions.updateProvider, (state) => ({
    ...state,
    providerUpdating: true,
  })),
  on(SsoActions.updateProviderSuccess, (state, { provider }) => ({
    ...state,
    provider: { ...provider },
    providerUpdating: false,
    providerUpdatingError: null
  })),
  on(SsoActions.updateProviderFailure, (state, { error }) => ({
    ...state,
    providerUpdating: false,
    providerUpdatingError: error
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return ssoReducer(state, action);
}
